import { Zap } from "lucide-react";

import { cn } from "@/lib/utils";
import { MARKER_COLOR } from "components/CaseMap/mapLayers";

/**
 * An event, or a cluster of them, drawn as a badge rather than a pin so it
 * never reads as a machine.
 */
export function EventMarkerBadge({ label, selected }) {
  return (
    <div
      className={cn(
        "tw:flex tw:items-center tw:justify-center tw:rounded-full tw:text-[11px] tw:font-semibold tw:text-(--color-charcoal) tw:ring-2 tw:ring-white tw:drop-shadow-sm tw:transition-transform tw:hover:scale-110",
        selected && "tw:scale-125 tw:ring-3"
      )}
      style={{
        backgroundColor: MARKER_COLOR.event,
        width: 28,
        height: 28,
      }}
    >
      {label ?? <Zap className="tw:size-3.5" strokeWidth={2.5} />}
    </div>
  );
}
